// What happens to a cart edit the server has not acknowledged yet. With no cart in browser storage, an edit
// made while offline lives only in memory: it is retried with backoff, a banner says so, and closing the tab
// asks first. Plan IRO-3676 section 7. No Vue imports: node tests load this file directly.

export const OFFLINE_RETRY_BASE_MS = 3000
export const OFFLINE_RETRY_MAX_MS = 60000
export const OFFLINE_BANNER_TEXT =
	'You appear to be offline. Your latest cart change has not been saved yet. Keep this page open and we will save it as soon as the connection returns.'

export function offlineRetryDelay(attempt) {
	const n = Math.max(0, Number(attempt) || 0)
	return Math.min(OFFLINE_RETRY_MAX_MS, OFFLINE_RETRY_BASE_MS * 2 ** n)
}

export function initialCartSyncStatus() {
	return { unsaved: false, offline: false, retryAttempt: 0 }
}

/** The beforeunload handler: warns only while an edit is unsaved. Returns the listener to add/remove. */
export function createUnloadGuard(getStatus) {
	return function onBeforeUnload(event) {
		if (!getStatus()?.unsaved) return undefined
		event.preventDefault()
		// Chrome still requires returnValue to show the prompt; the text itself is ignored by modern browsers.
		event.returnValue = OFFLINE_BANNER_TEXT
		return OFFLINE_BANNER_TEXT
	}
}
